import { Flex, Text } from '@chakra-ui/react';
import { isFuture } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { dateToString } from '@/utils/date';

interface ILectureCardUpcomingImagePlaceholderProps {
  publishedAt: string;
}

/*
LectureCardUpcomingImagePlaceholder is quite a log name but we don't have a better solution now
maybe we need to make core card component e.g.

<Card>
  <CardImage src="" alt="" />
  <CardImagePlaceholder>Some text</CardImagePlaceholder>
  <CardTag />
  <CardHeading />
  <CardLiveIndicator />
  <CardDescription />
</Card>

*/

export const LectureCardUpcomingImagePlaceholder: FC<ILectureCardUpcomingImagePlaceholderProps> = ({ publishedAt }) => {
  const { t } = useTranslation();
  const isPublishedInFuture = isFuture(new Date(publishedAt));
  const publishedDate = dateToString(publishedAt, 'LLL d, yyyy');

  return (
    <Flex p={4} bgColor="black" color="white" w="full" h="174px" alignItems="center" justifyContent="center">
      <Text fontSize="1.25rem" lineHeight={7} fontFamily="heading">
        {isPublishedInFuture ? t('common.comingAt', { date: publishedDate }) : t('common.comingSoon')}
      </Text>
    </Flex>
  );
};
